import { useTranslation } from "@bounce/i18n"

import type { Interpolations } from "../../CityScreen/hooks/useInterpolations"

export const Title = ({
  storesCount,
  interpolations,
  hasSearchTerm,
}: {
  storesCount: number
  interpolations: Interpolations
  hasSearchTerm: boolean
}) => {
  const { t } = useTranslation("marketing-ls-city")

  const cityTitle = t(
    "screen.cityListViewScreen.storesGrid.title",
    "{count, plural, =1 {Top Bounce luggage storage location} other {Top # Bounce luggage storage locations}} in {CITY_NAME}",
    {
      count: storesCount,
      CITY_NAME: interpolations.CITY_NAME,
    },
  )

  const addressTitle = t(
    "screen.cityListViewScreen.storesGrid.addressTitle",
    "{count, plural, =1 {Top Bounce luggage storage location} other {Top # Bounce luggage storage locations}}",
    {
      count: storesCount,
      NUM_LOCATIONS: interpolations.STORAGE_SPOT_COUNT,
    },
  )

  const title = hasSearchTerm ? addressTitle : cityTitle

  return (
    <div className="w-full max-w-screen-lg px-6 pt-8 lg:px-0 lg:pt-20">
      <h1 className="title2 break-words">{title}</h1>
    </div>
  )
}
